import {customElement, property, query} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {ifDefined} from "lit/directives/if-defined.js";
import {unsafeHTML} from "lit/directives/unsafe-html.js";
import {checkboxEvent} from "./inputEvents";
import type {Nullable} from "../../../bootstrap/common/types";
import {UnLitElement} from "../../../common/elements";

@customElement("eop-checkbox")
export class EopCheckbox extends UnLitElement {

    @property({attribute: "label"})
    public label: string;
    @property({attribute: "aria-label"})
    public ariaLabel: string;
    @property({attribute: "input-id"})
    public inputId: string;
    @property({attribute: "checked", type: Boolean})
    public checked: boolean;
    @property({attribute: "required", type: Boolean})
    public required: boolean;
    @property({attribute: "invalid", type: Boolean})
    public invalid: boolean;
    @property({attribute: "valid", type: Boolean})
    public valid: boolean;
    @property({attribute: "warning", type: Boolean})
    public warning: boolean;

    @query("input")
    private input: HTMLInputElement;

    protected render(): TemplateResult {
        return html`
            <label>
                <input type="checkbox"
                       id=${(this.inputId)}
                       aria-label=${ifDefined(this.ariaLabel)}
                       ?checked=${this.checked}
                       ?required=${this.required}
                       @input=${this.toggle}>
                <span class="box"><eop-svg-sprite-icon name="check_tick"></eop-svg-sprite-icon></span>
                ${this.renderLabel()}
            </label>
        `;
    }

    private renderLabel(): Nullable<TemplateResult> {
        if (!this.label || this.label.length === 0) {
            return null;
        }
        return html`<span class="checkbox-label">${unsafeHTML(this.label)}</span>`;
    }

    private toggle(): void {
        this.dispatchEvent(checkboxEvent(this.inputId, this.input.checked));
    }

    public focusInput(): void {
        this.input.focus();
    }
}